import React, { useState, useEffect } from 'react';
import SimplePDFViewer from './SimplePDFViewer';

function CodeitCertificates() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // public/codeit-list.json 파일에서 파일 목록 가져오기
    const loadCertificates = async () => {
      try {
        setLoading(true);
        const response = await fetch('/codeit-list.json');
        if (!response.ok) {
          throw new Error('수료증 목록을 불러올 수 없습니다.');
        }
        
        const certificateFiles = await response.json();
        
        // 파일명에서 .pdf 확장자만 제거하여 강의 제목 추출
        const processedCertificates = certificateFiles.map((filename) => {
          // 파일명에서 .pdf 확장자 제거
          const name = filename.replace(/\.pdf$/i, '');
          return {
            filename,
            name,
            path: `/codeit/${filename}`,
          };
        });

        // 이름 순으로 정렬
        processedCertificates.sort((a, b) => a.name.localeCompare(b.name, 'ko'));
        
        setCertificates(processedCertificates);
        setLoading(false);
      } catch (error) {
        console.error('수료증 목록 로드 실패:', error);
        setLoading(false);
      }
    };

    loadCertificates();
  }, []);

  if (loading) {
    return (
      <div className="codeit-loading">
        <div>수료증 목록을 불러오는 중...</div>
      </div>
    );
  }

  if (certificates.length === 0) {
    return (
      <div className="codeit-empty">
        <div>표시할 수료증이 없습니다.</div>
      </div>
    );
  }

  return (
    <div className="codeit-certificates-grid">
      {certificates.map((certificate, index) => (
        <div
          key={index}
          className="codeit-certificate-card"
        >
          <div className="codeit-certificate-header">
            <div className="codeit-certificate-name">{certificate.name}</div>
            <div className="codeit-certificate-badge">코드잇</div>
          </div>
          <div className="codeit-certificate-pdf">
            <SimplePDFViewer pdfPath={certificate.path} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default CodeitCertificates;

